// PublicRouter.tsx
import React, { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DEVICE_ID_KEY, JWT_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../../constants/auth'
import { useAuthStore } from '../../stores/auth';
import { getLocalStorage } from '../../utils/localStorage';

type PublicRouterProps = {
    Layout?: React.ComponentType<{ children?: React.ReactNode }> | null;
    Element: React.ComponentType<any>;
}

const PublicRouter = React.memo(({ Element, Layout }: PublicRouterProps) => {
    const navigate = useNavigate();
    const { user, loginWithToken } = useAuthStore();
    const jwt = (!!getLocalStorage(JWT_TOKEN_KEY) && !!getLocalStorage(REFRESH_TOKEN_KEY) && !!getLocalStorage(DEVICE_ID_KEY))


    const checkAuth = useCallback(() => {
        if (!!jwt && !!user) {
            navigate("/")
        }
    }, [jwt, user, navigate])

    useEffect(() => {
        if (!!jwt && !user) {
            loginWithToken();
        }
    }, [loginWithToken, jwt, user])

    useEffect(() => {
        checkAuth()
    }, [checkAuth, jwt, user])

    return Layout ? (
        <Layout>
            <Element />
        </Layout>
    ) : (
        <Element />
    )
})

export default PublicRouter